import { render, staticRenderFns } from "./OrgCreate.vue?vue&type=template&id=1edf3624&"
import script from "./OrgCreate.vue?vue&type=script&lang=js&"
export * from "./OrgCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports